import { Head } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout'
import { UiGalleryScreen } from '@/components/screens/UiGalleryScreen'

/* The catalogue: every token, primitive and block with its variants and
 * states. If a decision is not shown here, it is not a decision the design
 * system has made — so a new component or variant is added here in the same
 * change that introduces it. */
export default function UiGallery() {
  return (
    <AppLayout>
      <Head title="Components" />
      <UiGalleryScreen />
    </AppLayout>
  )
}
